/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input } from '@angular/core';
import { ReportService } from '../../../services/report.service';
import { FilterOptions, FilterValueType, ReportLinkField } from '../../../state/report.model';
import { ReportFilterService } from '../../../services/report-filter.service';

@Component({
    selector: 'dash-gis-reportlink-field',
    templateUrl: './reportlink-field.component.html',
    styleUrls: ['./reportlink-field.component.scss'],
})
export class ReportlinkFieldComponent {
    @Input() public rowData: any;
    @Input() public fieldDefinition: ReportLinkField;

    constructor(private reportService: ReportService, private filterService: ReportFilterService) {}

    runReportByName(evt: { name: string; key: any; filter?: any }) {
        return this.reportService.runReportByName(evt);
    }

    getFilterParameters(field: ReportLinkField, rowData: any[]): false | FilterOptions {
        let value: FilterValueType;
        if (!field.filterField) {
            return false;
        }
        if (field.filterMinValue || field.filterMaxValue) {
            value = {};
            if (field.filterMinValue) {
                value['min'] = this.filterService.convertFilterInput(field.filterType, rowData[field.filterMinValue]);
            }
            if (field.filterMaxValue) {
                value['max'] = this.filterService.convertFilterInput(field.filterType, rowData[field.filterMaxValue]);
            }
        } else {
            value = {
                value: this.filterService.convertFilterInput(field.filterType, rowData[field.filterValue]).toString()
            };
        }
        return this.filterService.getFilterValue(field.filterType, field.filterField, value);
    }
}
